import { render, staticRenderFns } from "./TargetingNumberOfVisitedPages.vue?vue&type=template&id=2da54060&"
import script from "./TargetingNumberOfVisitedPages.vue?vue&type=script&lang=js&"
export * from "./TargetingNumberOfVisitedPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports